import { LabelBodySmall } from '../components';
import { CheckCircle, LockIcon } from '../icons';
import { ExerciseStatus } from '../interfaces';

type Props = {
    hasLoggedData: boolean;
    status: ExerciseStatus;
    isVideo: boolean;
    useCheckmark?: boolean;
};
export function ExerciseStatusView({
    hasLoggedData,
    status,
    isVideo,
    useCheckmark = false,
}: Props) {
    switch (status) {
        case ExerciseStatus.Blocked:
            return <LockIcon />;
        case ExerciseStatus.Completed:
            return isVideo ? (
                <LabelBodySmall color="text-vibrant-blue">
                    Afspillet
                </LabelBodySmall>
            ) : useCheckmark ? (
                <CheckCircle className="text-vibrant-blue"></CheckCircle>
            ) : (
                <LabelBodySmall color="text-vibrant-blue">
                    {hasLoggedData ? 'Gemt i logbogen' : 'Udført'}
                </LabelBodySmall>
            );
        case ExerciseStatus.InProgress:
            return null;
        case ExerciseStatus.Open:
            return null;
    }
}
